import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getEquiposFracttal = async () => {
    try {      
      const {data}  = await Axios.get(
        `/equipos/fracttal`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };